import {Dimensions} from 'react-native';
import {isIphoneX} from 'react-native-iphone-screen-helper';
import {RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';

import LinearGradient from 'react-native-linear-gradient';
import {createShimmerPlaceholder} from 'react-native-shimmer-placeholder';

const ShimmerPlaceHolder = createShimmerPlaceholder(LinearGradient);

export const Row = styled.View`
  flex-direction: row;
  padding: 0 24px;
  width: 100%;
  justify-content: space-between;
  margin-top: ${RFValue(12)}px;
`;
export const ProductCategoryItem = styled.View`
  width: 50%;
`;

const imageDimensions = isIphoneX()
  ? Dimensions.get('window').width >= 393 &&
    Dimensions.get('window').width < 430
    ? RFValue(58)
    : Dimensions.get('window').width >= 394 &&
      Dimensions.get('window').width < 431
    ? RFValue(62)
    : RFValue(68)
  : RFValue(72);

export const ProductCategoryImage = styled(ShimmerPlaceHolder)`
  height: ${imageDimensions}px;
  width: auto;
  border-radius: ${RFValue(14)}px;
`;
